import { Component, computed } from '@angular/core';
import { CustomWidget } from '../widget';
import { CommonModule } from '@angular/common';
import { NumberPipe } from '@pipes/number.pipe';
import { AbbIconComponent } from '@components/abb-icon/abb-icon.component';
import { Icon } from '@components/abb-icon/icons';
import { TPipe, TRANSLATION_PREFIX } from '@pipes/t.pipe';

@Component({
  selector: 'abb-water-gas-widget',
  standalone: true,
  imports: [CommonModule, NumberPipe, AbbIconComponent, TPipe],
  template: `
    @if (propertyOrGroup()) {
    <div
      class="flex justify-between gap-x-5 text-sm text-abb-font/70 font-medium"
    >
      <div class="flex-1 text-center bg-abb-black/[0.02] py-3 rounded-sm">
        {{ propertyOrGroup() }}
      </div>
      <div class="flex-1 text-center bg-abb-black/[0.02] py-3 rounded-sm">
        {{ resolution() }}
      </div>
    </div>
    <div
      class="mt-4 flex justify-center gap-x-10 items-center text-3xl font-bold"
    >
      <div class="flex justify-center py-3">
        <abb-icon
          [ngStyle]="{
            color:
              iconName() === 'mat-outlined/water_drop' ? '#3B82F6' : '#EF4444'
          }"
          [name]="iconName()"
          [size]="'large'"
          externalSize="text-6xl"
        ></abb-icon>
      </div>
      <div class="text-center rounded-sm">
        {{ value() | number }} m<sup>3</sup>
      </div>
    </div>
    } @else {
    <div
      class="flex items-center justify-center h-full text-center text-abb-font/70"
    >
      {{ "You don't have permission to view this property or group" | t }}
    </div>
    }
  `,
  styles: ``,
  providers: [
    {
      provide: TRANSLATION_PREFIX,
      useValue: 'dashboards',
    },
  ],
})
export class WaterGasWidgetComponent extends CustomWidget {
  iconName = computed<Icon>(() => {
    const data = this.data();
    if (data && data.__typename === 'WaterGasData') {
      return data.icon === 'water'
        ? 'mat-outlined/water_drop'
        : 'mat-outlined/local_fire_department';
    }
    return 'mat-outlined/question_mark';
  });
  value = computed(() => {
    const data = this.data();
    if (data && data.__typename === 'WaterGasData') {
      return data.value;
    }
    return 0;
  });
  propertyOrGroup = computed(() => {
    const data = this.data();
    if (data && data.__typename === 'WaterGasData') {
      return data.propertyOrGroup;
    }
    return '';
  });
  resolution = computed(() => {
    const data = this.data();
    if (data && data.__typename === 'WaterGasData') {
      return data.resolution;
    }
    return '';
  });
}
